export const onXmapsReportingData = {
    projectHeading: 'The onXmaps Report Tool Project',
    projectMainImage: {
        image: '/images/portfolio/reporting-tool/onxmaps-reporting-tool.jpg',
        alt: 'onXmaps Reporting Tool'
    },
    additionalImages: [
        {
            fullImage: '/images/portfolio/reporting-tool/success.jpg',
            image: '/images/portfolio/reporting-tool/success-thumb.jpg',
            alt: 'Reporting Tool Login Screen'
        },
        {
            fullImage: '/images/portfolio/reporting-tool/logout-mockout.jpg',
            image: '/images/portfolio/reporting-tool/logout-mockout-thumb.jpg',
            alt: 'Reporting Tool Logout'
        }
    ],
    aboutHeading: 'About The onXmaps Reporting Tool',
    aboutPortfolioText: [
        `The onXmaps Reporting Tool was a project requested by upper management as a way to visualize various
         metrics of data in a graphical way for the company. The company had multiple e-commerce sites, which, this
         tool was a way to access the data from a central location.`,

        `The project was initialized by upper management, but it was left in my hands to choose the tech stack,
         layout, and design of the system. There were set requirements that had to be met. Aside from those requirements,
         I had complete freedom to experiment with various frameworks and technologies—as-long-as I accomplish
         the project in a given timeline.`
    ],
    websiteGoalsHeading: 'Website Goals',
    websiteGoalsText: [
        `The purpose of the onXmaps Reporting Tool was to be a central location to pull in data from various
         data sources, so they can be easily seen and visualized. This tool was to be accessible from everyone within the
         company, as many would be able to use it to track their bonus.`
    ],
    websiteGoalsListHeading: 'Website Goals List',
    websiteGoalsList: [
        `Acquire data in real time from several sources`,
        `Contain graphs to visually display the data`,
        `Have a calculator for employees to calculate their bonus`,
        `Be built to be scalable`,
        `Work with Mobile Devices`,
    ],
    myRoleHeading: 'My Role On The onXmaps Reporting Tool Project',
    position: 'Lead Web Developer',
    company: 'onXmaps Inc.',
    timeWithCompany: '3 years, 5 months',
    myRoleText: [
        `As the primary lead developer on this project, I was charged with taking the initial concept of the project,
         and running it through the process of design, architecture, and delivery all on my own.`,

        `I was able to design
         the mockups and get approval for them. Afterwards, I was able to architect the dataflow from the databases, and
         determine the tech stack to use to accomplish this. Afterwards, I was able to execute on this plan unto completion.`
    ],
    jobSummaryIntro: 'Following is a summary of my responsibilities while working on the onXmaps Reporting Tool',
    jobSummaryList: [
        `Design the website using Photoshop`,
        `Lay out the pipeline for the new website`,
        `Build and deliver entire project in a couple of months`,
        `Build the backend in Laravel`,
        `Build the frontend in AngularJS (1.5)`,
        `Research and build the data using Google Charts`,
        `Work close with stakeholders on requirements`,
    ],
    technologiesUsedIntro: `This section contains the technologies used for building the onXmaps Reporting Tool`,
    technologiesList: [
        `Photoshop`,
        `Illustrator`,
        `Google Charts`,
        `Laravel`,
        `AngularJS`,
        `HTML5`,
        `CSS3`,
        `JavaScript`,
        `MySQL`,
        `Magento 1.9`,
        `Git`,
        `Twitter Bootstrap`,
        `Responsive Design`,
        `Red Hat Server`,
        `PHP`,
        `Sass`,
    ]
}